import { PublicClientApplication } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "88b1e9b9-eae0-4f1e-8213-36b1b80de990",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "https://crewflow-dev.pingitright.com",
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
